module.exports = __webpack_public_path__ + "static/media/img-placeholder-squared.ee72087d.svg";